import React, { Component } from "react";
import Viewer from "react-viewer";
import styles from "./ProductArticle.module.css";
import Language from "../utils/Language";

class ProductArticle extends Component {
  constructor(props) {
    super(props);
    this.state = { viewerImageIndex: undefined };
  }

  openViewer = index => this.setState({ viewerImageIndex: index });
  closeViewer = () => this.setState({ viewerImageIndex: undefined });

  render() {
    const { viewerImageIndex } = this.state;
    const { languages, store, videos, images, symbol } = this.props.article;

    let selected = Language.GetLangId();
    if (selected >= languages.length) selected = 0;
    const { name, price, description } = languages[selected];

    const safeVideos = videos || [];
    const safeImages = images || [];

    const viewerImages = safeImages.map(img => ({ src: img.full, alt: "" }));

    return (
      <article className={styles.Card}>
        <div className={styles.Cover}>
          <div className={styles.CoverHead}>
            {symbol && <img className={styles.Symbol} alt="" src={symbol} />}
            <h2 className={styles.Name}>{name}</h2>
          </div>

          <div className={styles.PriceRow}>
            {price && <span className={styles.Price}>{price}</span>}
            {store && (
              <a
                className={styles.StoreCta}
                href={store.href}
                target="_blank"
                rel="noreferrer"
              >
                {store.name} →
              </a>
            )}
          </div>
        </div>

        <div className={styles.Body}>
          <p className={styles.Description}>{description}</p>

          {(safeVideos.length > 0 || safeImages.length > 0) && (
            <div className={styles.Gallery}>
              {safeVideos.map(vid => (
                <a
                  key={vid.src}
                  className={styles.Thumb}
                  href={vid.src}
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Video"
                >
                  <img alt="" src={vid.thumb} loading="lazy" />
                  <span className={styles.PlayBadge}>▶</span>
                </a>
              ))}
              {safeImages.map((img, index) => (
                <button
                  type="button"
                  key={img.thumb}
                  className={styles.Thumb}
                  onClick={() => this.openViewer(index)}
                  aria-label={Language.GetString("view_gallery")}
                >
                  <img alt="" src={img.thumb} loading="lazy" />
                </button>
              ))}
            </div>
          )}
        </div>

        <Viewer
          visible={viewerImageIndex !== undefined}
          activeIndex={viewerImageIndex}
          onClose={this.closeViewer}
          rotatable={false}
          scalable={false}
          onMaskClick={this.closeViewer}
          noImgDetails
          images={viewerImages}
        />
      </article>
    );
  }
}

export default ProductArticle;
